<div class="term-input-container" [ngClass]="{'has-errors': hasErrors}">
    <boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames"
        (errorChange)="hasErrors=$event">
    </boi-validation-error-generic>
    <kendo-textbox-container>
        <div class="field-container {{cssClasses}}">
            <div class="field-label d-flex">
                <label [for]="controlId || labelName" class="w-auto">
                    <span [innerHtml]="labelName|localizeLabel"></span>                    
                </label>
                <boi-tooltip [tooltipName]="tooltipName || labelName"></boi-tooltip>
            </div>
            <div class="field-input">
                <kendo-numerictextbox [disabled]="isFieldDisabled" [id]="controlId||labelName" [spinners]="false"
                    [step]="0" [(ngModel)]="years" [min]="0" [max]="99" [format]="'n'"
                    (ngModelChange)="yearsChange.emit(years)" [title]="addTitleToInputs ? ((tooltipName || labelName) | localizeTooltip) : undefined"
                    autoCorrect="true"></kendo-numerictextbox>
                <span class="value-unit" [innerHtml]="referenceDataLabels.YearsId|localizeLabel"></span>
                <kendo-numerictextbox [disabled]="isFieldDisabled" [spinners]="false" [step]="0" [(ngModel)]="months"
                    [min]="0" [max]="11" [format]="'n'" (ngModelChange)="monthsChange.emit(months)" autoCorrect="true"
                    [title]="addTitleToInputs ? ((tooltipName || labelName) | localizeTooltip) : undefined"></kendo-numerictextbox>
                <span class="value-unit" [innerHtml]="referenceDataLabels.MonthsId | localizeLabel"></span>
            </div>
        </div>
    </kendo-textbox-container>
</div>